module.exports = __webpack_public_path__ + "img/check-mark-verified.cbae2dfd.gif";